import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonDirective, CardBodyComponent, CardComponent } from '@coreui/angular';
import { IconDirective } from '@coreui/icons-angular';

@Component({
    standalone: true,
    imports: [CardComponent, CardBodyComponent, ButtonDirective, IconDirective],
    templateUrl: './not-found.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
    constructor(private router: Router) {}

    goHome() {
        this.router.navigate(['/']);
    }
}
